const BrunaeCart = (() => {

  const cfg = () => ({
    currency:  window.BrunaeCurrency || 'AED',
    upsellMap: window.BrunaeUpsellMap || {},
  });

  const fmt = (cents, currency) =>
    (currency || cfg().currency) + ' ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  let _upsellCache = {};
  const open = () => {
    document.getElementById('cart-drawer').classList.add('is-open');
    document.getElementById('cart-drawer-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  };

  const close = () => {
    document.getElementById('cart-drawer').classList.remove('is-open');
    document.getElementById('cart-drawer-overlay').classList.remove('is-open');
    document.body.style.overflow = '';
  };
  const fetchCart = async () => {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      render(cart);
    } catch (e) { console.error('[BrunaeCart] fetchCart:', e); }
  };
  const updateQty = async (key, qty) => {
    try {
      const cart = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      }).then(r => r.json());
      render(cart);
      syncHeaderBubble(cart.item_count);
    } catch (e) { console.error('[BrunaeCart] updateQty:', e); }
  };

  const removeItem = (key) => updateQty(key, 0);
  const addUpsell = async (variantId, btn) => {
    btn.classList.add('is-loading');
    btn.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation:spin .6s linear infinite"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>`;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>`;
      fetchCart();
    } catch (e) {
      console.error('[BrunaeCart] addUpsell:', e);
      btn.classList.remove('is-loading');
      btn.innerHTML = '+';
    }
  };
  const syncHeaderBubble = (count) => {
    document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(el => {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden');
    });
    const c = document.getElementById('cart-drawer-count');
    if (c) c.textContent = count;
  };

  const fetchProduct = async (handle) => {
    if (_upsellCache[handle]) return _upsellCache[handle];
    try {
      const res  = await fetch(`/products/${handle}.js`).then(r => r.json());
      _upsellCache[handle] = res;
      return res;
    } catch (e) {
      console.warn('[BrunaeCart] upsell product not found:', handle);
      return null;
    }
  };
  const getProductImage = (p) => {
    let src = null;
    if (typeof p.featured_image === 'string' && p.featured_image) {
      src = p.featured_image;
    }
    else if (Array.isArray(p.images) && p.images.length > 0) {
      const img = p.images[0];
      src = typeof img === 'string' ? img : (img?.src || img?.url || null);
    }
    else if (Array.isArray(p.media) && p.media.length > 0) {
      const imgMedia = p.media.find(m => m.media_type === 'image') || p.media[0];
      src = imgMedia?.src || imgMedia?.preview_image?.src || null;
    }

    if (!src) return null;
    const clean = src.split('?')[0].replace(/_\d+x\d*(\.[^.]+)$/, '$1');
    return clean.replace(/(\.[a-zA-Z]{3,4})$/, '_120x120$1');
  };
  const renderUpsells = async (cartItems) => {
    const { upsellMap, currency } = cfg();
    const upsellSection   = document.getElementById('cart-drawer-upsell');
    const upsellContainer = document.getElementById('upsell-items-container');
    if (!upsellSection || !upsellContainer) return;

    const cartProductIds = cartItems.map(i => String(i.product_id));
    const handles = new Set();
    cartProductIds.forEach(id => (upsellMap[id] || []).forEach(h => handles.add(h)));

    const cartHandles = new Set(cartItems.map(i => i.handle));
    const toShow = [...handles].filter(h => !cartHandles.has(h));

    if (toShow.length === 0) { upsellSection.style.display = 'none'; return; }

    upsellSection.style.display = 'block';
    upsellContainer.innerHTML = `<div class="cart-drawer__spinner"></div>`;

    const products = (await Promise.all(toShow.map(fetchProduct))).filter(Boolean);
    if (products.length === 0) { upsellSection.style.display = 'none'; return; }

    upsellContainer.innerHTML = products.map((p, i) => {
      const v       = p.variants[0];
      const imgSrc  = getProductImage(p);
      const price     = fmt(v.price, currency);
      const compareAt = v.compare_at_price && v.compare_at_price > v.price
        ? fmt(v.compare_at_price, currency) : null;

      return `
        <div class="upsell-card" style="animation-delay:${i * 0.07}s">
          <div class="upsell-card__img-wrap">
            ${imgSrc
              ? `<img class="upsell-card__image"
                      src="${imgSrc}"
                      alt="${p.title}"
                      loading="lazy"
                      onerror="this.parentElement.innerHTML='<div class=upsell-card__image-placeholder><svg width=18 height=18 viewBox=\'0 0 24 24\' fill=none stroke=currentColor stroke-width=1><rect x=3 y=3 width=18 height=18 rx=2/><path d=\'M3 9h18M9 21V9\'/></svg></div>'">`
              : `<div class="upsell-card__image-placeholder">
                   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>
                 </div>`
            }
          </div>
          <div class="upsell-card__info">
            <div class="upsell-card__label">Add On</div>
            <div class="upsell-card__title">${p.title}</div>
            <div class="upsell-card__price">${price}${compareAt ? ` <span style="text-decoration:line-through;color:#aaa;font-size:11px">${compareAt}</span>` : ''}</div>
          </div>
          <button class="upsell-card__add" onclick="BrunaeCart.addUpsell(${v.id}, this)" aria-label="Add ${p.title}">+</button>
        </div>`;
    }).join('');
  };
  const render = (cart) => {
    const itemsEl    = document.getElementById('cart-drawer-items');
    const emptyEl    = document.getElementById('cart-drawer-empty');
    const footerEl   = document.getElementById('cart-drawer-footer');
    const subtotalEl = document.getElementById('cart-drawer-subtotal');
    const { currency } = cfg();

    syncHeaderBubble(cart.item_count);
    if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price, currency);

    if (cart.item_count === 0) {
      if (itemsEl)  itemsEl.innerHTML = '';
      if (emptyEl)  emptyEl.style.display = 'flex';
      if (footerEl) footerEl.style.display = 'none';
      const upsell = document.getElementById('cart-drawer-upsell');
      if (upsell) upsell.style.display = 'none';
      return;
    }

    if (emptyEl)  emptyEl.style.display  = 'none';
    if (footerEl) footerEl.style.display = 'block';

    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map((item, i) => `
        <div class="cart-item" style="animation-delay:${i * 0.05}s">
          <div class="cart-item__left">
            ${item.image
              ? `<img class="cart-item__image" src="${item.image}" alt="${item.title}" loading="lazy">`
              : `<div class="cart-item__image-placeholder"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg></div>`}
            <div class="cart-item__info">
              ${item.vendor ? `<div class="cart-item__vendor">${item.vendor}</div>` : ''}
              <div class="cart-item__title">${item.product_title}</div>
              ${item.variant_title && item.variant_title !== 'Default Title'
                ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
              <div class="cart-item__price">${fmt(item.line_price, currency)}</div>
            </div>
          </div>
          <div class="cart-item__right">
            <button class="cart-item__remove" onclick="BrunaeCart.removeItem('${item.key}')" aria-label="Remove">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M3 6h18M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6M10 11v6M14 11v6"/>
                <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
              </svg>
            </button>
            <div class="cart-item__qty">
              <button onclick="BrunaeCart.updateQty('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
              <span class="cart-item__qty-value">${item.quantity}</span>
              <button onclick="BrunaeCart.updateQty('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
            </div>
          </div>
        </div>`).join('');
    }

    renderUpsells(cart.items);
  };

  const interceptAddToCart = () => {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      const btn = form.querySelector('[type="submit"], [name="add"]');
      const orig = btn ? btn.innerHTML : '';
      if (btn) { btn.innerHTML = '<span style="opacity:.6">Adding…</span>'; btn.disabled = true; }

      try {
        await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        open();
      } catch (err) {
        console.error('[BrunaeCart] form add failed:', err);
      } finally {
        if (btn) { btn.innerHTML = orig; btn.disabled = false; }
      }
    }, true); 

    const _origFetch = window.fetch;
    window.fetch = async function(...args) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      const method = (args[1]?.method || 'GET').toUpperCase();

      const res = await _origFetch.apply(this, args);
      if (method === 'POST' && url.includes('/cart/add')) {
        const cloned = res.clone();
        cloned.json().then(data => {
          if (data && !data.status) {
            setTimeout(open, 80);
          }
        }).catch(() => {});
      }

      return res;
    };
  };
  const interceptCartIcon = () => {
    document.addEventListener('click', (e) => {
      const icon = e.target.closest('a[href="/cart"], .header__icon--cart, [data-cart-toggle]');
      if (!icon) return;
      if (icon.closest('#cart-drawer')) return;
      e.preventDefault();
      open();
    });
  };
  const bindKeyboard = () => {
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  };

  const init = () => {
    interceptAddToCart();
    interceptCartIcon();
    bindKeyboard();
  };

  return { init, open, close, fetchCart, updateQty, removeItem, addUpsell };

})();

document.addEventListener('DOMContentLoaded', BrunaeCart.init);
function closeCartDrawer() { BrunaeCart.close(); }